import * as types from "../../actions/profile/actionTypes";
import initialState from "../initialState";

export default function profileReducer(state = initialState.profile, action) {
  switch (action.type) {
    case types.LOAD_PROFILE:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          ...action.data,
        },
      };

    case types.REMOVE_PROFILE:
      return {
        ...initialState.profile,
      };

    case types.DECRESE_UNREAD_MESSAGES_COUNT:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          unreadMessagesCount:
            state.userDetails.unreadMessagesCount - (action.data?.count ?? 1),
        },
      };
    case types.UPDATE_UNREAD_MESSAGES_COUNT:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          unreadMessagesCount: action.data?.count ?? 0,
        },
      };

    case types.ADJUST_UNREAD_MESSAGES_COUNT:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          unreadMessagesCount:
            state.userDetails.unreadMessagesCount + (action.data?.count ?? 0),
        },
      };

    case types.ADJUST_UNREAD_NOTIFICATIONS_COUNT:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          unreadNotificationsCount:
            state.userDetails.unreadNotificationsCount +
            (action.data?.count ?? 0),
        },
      };

    default:
      return state;
  }
}
